module.exports = __webpack_public_path__ + "img/b346131.svg";